import { Program } from '../../model/program.model'
import { Folder } from '../../model/study.model'

interface BrokerState {
  currentClientID: string | null
  currentClientID2: string | null
  currentYearID: string | null
  currentYearID2: string | null
  currentStudyID: string | null
  currentStudyID2: string | null
  currentStructureID: string | null
  currentAnalysisProfile: any | null
  structureFilter: string | null
  groupFilterByAssoc: boolean
  checkedPrograms: Program[]
  currencies: any[]
  currencyRates: any[]
  folders: Folder[]
}

export interface State {
  broker: BrokerState
  checkedProgram: Program[]
}

export const initialState: BrokerState = {
  currentClientID: null,
  currentClientID2: null,
  currentYearID: null,
  currentYearID2: null,
  currentStudyID: null,
  currentStudyID2: null,
  currentStructureID: null,
  currentAnalysisProfile: null,
  structureFilter: null,
  groupFilterByAssoc: true,
  checkedPrograms: [],
  currencies: [],
  currencyRates: [],
  folders: [],
}
